import type { ReactNode } from "react";
import cx from "ui/cx";
import IconInfoLine from "ui/icons/IconInfoLine";
import Tooltip from "ui/popovers/Tooltip";
import styles from "./TextWithTooltipIcon.module.scss";

export interface TextWithTooltipIconProps {
  text: ReactNode;
  tooltip: ReactNode;
  icon?: ReactNode;
  className?: string;
  /** Applied to the tooltip bubble, for structured content that needs its own width or typography */
  tooltipClassName?: string;
}

export default function TextWithTooltipIcon({
  text,
  tooltip,
  icon,
  className = "",
  tooltipClassName,
}: TextWithTooltipIconProps) {
  return (
    <div className={cx(styles.wrapper, className)}>
      {typeof text === "string" ? <span>{text}</span> : text}
      {/* Matches `wrapWithTooltip`: no tooltip content means no icon to hover, rather than an empty bubble */}
      {!!tooltip && (
        <Tooltip.Root delayDuration={0}>
          <Tooltip.Trigger>
            <div className="icon-container">{icon ?? <IconInfoLine size={18} color="stone" />}</div>
          </Tooltip.Trigger>
          <Tooltip.Content className={tooltipClassName}>{tooltip}</Tooltip.Content>
        </Tooltip.Root>
      )}
    </div>
  );
}
